import { Player } from "@remotion/player";
import ProductVideo from "./ProductVideo";
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import { getVideoDimensions } from "../utils/videoFormats";
import { abrirModalPlanos } from "../components/precos"

function PlayInner({ produtos, video, setCreditos, creditos, user, audioGravadoUrl, modoGravando }, ref) {
  const [videoFormat, setVideoFormat] = useState(video?.formato || "story");
  const { width: compositionWidth, height: compositionHeight } =
    getVideoDimensions(videoFormat);


  const [baixando, setBaixando] = useState(false);
  const [renderId, setRenderId] = useState(null);
  const [progresso, setProgresso] = useState(0);

  const podeBaixarSemCredito = user?.origem === "crieoferta";


//AJUSTAR O TAMANHO DO VIDEO NA TELA

  const containerRef = useRef(null);
  const [playerSize, setPlayerSize] = useState({ width: 0, height: 0 });

  // Calcular tamanho inicial imediatamente
  useEffect(() => {
    const calculateInitialSize = () => {
      if (!containerRef.current) return;
      
      const { width: containerWidth, height: containerHeight } =
        containerRef.current.getBoundingClientRect();

      if (!containerWidth || !containerHeight) return;

      const scale = Math.min(
        containerWidth / compositionWidth,
        (containerHeight) / compositionHeight
      );

      setPlayerSize({
        width: Math.floor(compositionWidth * scale),
        height: Math.floor(compositionHeight * scale),
      });
    };

    // Calcular imediatamente
    calculateInitialSize();

    // Adicionar um pequeno delay para garantir que o DOM esteja completamente renderizado
    const timeoutId = setTimeout(calculateInitialSize, 100);

    // Configurar observer para mudanças de tamanho
    const observer = new ResizeObserver(() => {
      calculateInitialSize();
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [compositionWidth, compositionHeight, videoFormat]); // Adicione videoFormat como dependência

//FIM DO AJUSTAR O TAMANHO DO VIDEO NA TELA




  const playerRef = useRef(null);
  useImperativeHandle(ref, () => ({
    play: () => playerRef.current?.play?.(),
    pause: () => playerRef.current?.pause?.(),
    isPlaying: () => playerRef.current?.isPlaying?.(),
    getCurrentFrame: () => playerRef.current?.getCurrentFrame?.(),
    seekTo: (frame) => playerRef.current?.seekTo?.(frame),
    getDuration: () => duracaoTotal,
    addEventListener: (eventName, callback) =>
      playerRef.current?.addEventListener?.(eventName, callback),
    removeEventListener: (eventName, callback) =>
      playerRef.current?.removeEventListener?.(eventName, callback),
  }));

  const fps = 30;
  const tempoLogo = 4 * fps;

  // Configurações de mensagens / redes
  const msgAberturaEnabled = !!(video?.msg_abertura_enabled === 1 || video?.msg_abertura_enabled === '1' || video?.msg_abertura_enabled === true);
  const msgEncerramentoEnabled = !!(video?.msg_encerramento_enabled === 1 || video?.msg_encerramento_enabled === '1' || video?.msg_encerramento_enabled === true);
  const redesEnabled = !!(video?.redes_enabled === 1 || video?.redes_enabled === '1' || video?.redes_enabled === true);
  const redesOutroEnabled = !!(video?.redes_outro === 1 || video?.redes_outro === '1' || video?.redes_outro === true);
  let redesSociais = null;
  try {
    const cfg = typeof video?.redes_sociais === 'string'
      ? JSON.parse(video.redes_sociais || '{}')
      : (video?.redes_sociais || {});
    // Valores das redes vêm do PERFIL do usuário (campos usuario_*)
    const valoresUsuario = {
      instagram: video?.usuario_instagram || '',
      whatsapp:  video?.usuario_whatsapp  || '',
      facebook:  video?.usuario_facebook  || '',
      site:      video?.usuario_site      || '',
      endereco:  video?.usuario_endereco  || '',
      tiktok:    cfg.tiktok               || '',
    };
    redesSociais = { ...valoresUsuario, _config: cfg._config || {} };
  } catch { redesSociais = null; }

  const msgDuracaoSegs = 3;
  const msgDurFrames = msgDuracaoSegs * fps;
  const temEncerramento = msgEncerramentoEnabled && (video?.msg_encerramento_texto || '').trim();

  const calcularDuracaoTotal = () => {
    let totalFrames = tempoLogo;

    if (produtos?.length) {
      produtos.forEach((produto) => {
        const tempo = Number(produto?.tempo_audio) || 4;
        totalFrames += tempo * fps;
      });
    }
    if (msgAberturaEnabled && (video?.msg_abertura_texto || '').trim()) totalFrames += msgDurFrames;
    if (video?.outro_audio && Number(video?.tempo_outro) > 0) totalFrames += (Number(video.tempo_outro) + 3) * fps;
    if (temEncerramento) totalFrames += msgDurFrames;
    return totalFrames;
  };

  const duracaoTotal = calcularDuracaoTotal();



const baixarVideo = async () => {

  setBaixando(true);

  try {
    // Upload do áudio gravado (blob) para URL pública antes de renderizar
    let audioGravadoFinal = audioGravadoUrl || null;
    if (audioGravadoFinal && audioGravadoFinal.startsWith("blob:")) {
      const blob = await fetch(audioGravadoFinal).then(r => r.blob());
      const fd = new FormData();
      fd.append("audio", blob, "gravacao.webm");
      const upRes = await fetch("https://videooferta.com/api/upload_audio_gravado.php", { method: "POST", body: fd });
      const upJson = await upRes.json();
      if (upJson.success) audioGravadoFinal = upJson.url;
      else throw new Error("Falha no upload do áudio gravado");
    }

    const res = await fetch("https://remotion.videooferta.com/render", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        selo: video.selo,
        background: video.background,
        products: produtos,
        intro: video.intro_audio,
        intro_time: video.tempo_audio,
        audio_fundo: video.musica_custom_url || video.musica_url,
        backgroundVideo: "",
        cor_etiqueta: video.cor_etiqueta,
        bg_etiqueta: video.bg_etiqueta,
        fonte: '"Montserrat", sans-serif',
        logo: video.logo,
        width: compositionWidth,
        height: compositionHeight,
        formato: videoFormat,
        msgAberturaEnabled,
        msgAberturaTexto: video?.msg_abertura_texto || '',
        msgEncerramentoEnabled,
        msgEncerramentoTexto: video?.msg_encerramento_texto || '',
        redesEnabled,
        redesOutroEnabled,
        redesSociais,
        msgDuracaoSegs,
        outroAudio: video?.outro_audio || null,
        outroTime: video?.outro_audio && Number(video?.tempo_outro) > 0 ? Number(video.tempo_outro) + 3 : 0,
        audioGravado: audioGravadoFinal,
        // Para callback do backend
        id_publico: video?.id_publico || null,
        video_id: video?.video_id || video?.id || null,
        titulo: video?.titulo || null,
      })
    });

    const { renderId } = await res.json();
    setRenderId(renderId);

    // Polling a cada 500ms
    await new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const pRes = await fetch(`https://remotion.videooferta.com/progress/${renderId}`);
          const { progresso } = await pRes.json();

          setProgresso(Math.max(0, Math.min(1, progresso)));

  console.log(progresso)


          if (progresso >= 1) {
            clearInterval(interval);
            resolve();
          }
          if (progresso === -1) {
            clearInterval(interval);
            reject(new Error("Erro na renderização"));
          }
        } catch (err) {
          clearInterval(interval);
          reject(err);
        }
      }, 500);
    });

    // Download após render finalizada
    const downloadRes = await fetch(`https://remotion.videooferta.com/download/${renderId}`);
    const blob = await downloadRes.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "video.mp4";
    a.click();
    window.URL.revokeObjectURL(url);

    // ✅ REGISTRAR DOWNLOAD E DESCONTAR CRÉDITOS
    await registrarDownload();

  } catch (err) {
    alert(err.message);
  } finally {
    setBaixando(false);
    setProgresso(0);
    setRenderId(null);
  }
};


const registrarDownload = async () => {
  try {
    const res = await fetch("https://videooferta.com/api/baixar_video.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id_user: user.id,
        video_id: video.id,
      }),
    });

    const json = await res.json();

    if (json.sucesso) {
      // ✅ Atualiza créditos no estado
      setCreditos(json.saldo_restante);
    } else {
      console.error("Erro ao registrar download:", json.erro);
    }
  } catch (err) {
    console.error("Erro na API de download:", err);
  }
};







  // Adicione um fallback visual enquanto o tamanho está sendo calculado
  if (playerSize.width === 0 || playerSize.height === 0 || !video === 0 || !produtos === 0) {
    return (
      <div className="d-flex flex-column h-100">
        <div 
          ref={containerRef}
          className="flex-grow-1 d-flex justify-content-center align-items-center"
          style={{ overflow: "hidden", width: "100%", maxWidth: "100vw" }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p>Carregando player...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 d-flex flex-column h-100">
      {/* CONTEÚDO CENTRAL */}
      <div 
        ref={containerRef}
        className="flex-grow-1 d-flex justify-content-center align-items-center"
        style={{ overflow: "hidden", width: "100%", maxWidth: "100vw" }}
      >
        <Player
          ref={playerRef}
          key={`${videoFormat}-${playerSize.width}-${redesEnabled ? '1' : '0'}-${redesOutroEnabled ? '1' : '0'}-${JSON.stringify(redesSociais || {})}-${audioGravadoUrl || 'none'}-${modoGravando ? '1' : '0'}`}
          component={ProductVideo}
          durationInFrames={Math.max(duracaoTotal, 1)}
          fps={fps}
          compositionWidth={compositionWidth}
          compositionHeight={compositionHeight}
          controls
          style={{
            width: playerSize.width,
            height: playerSize.height,
            background: "#000",
            borderRadius: "10px",
          }}
          inputProps={{
            selo: video.selo,
            background: video.background,
            products: produtos,
            intro: video.intro_audio,
            intro_time: video.tempo_audio,
            audio_fundo: video.musica_custom_url || video.musica_url,
            backgroundVideo: "",
            cor_etiqueta: video.cor_etiqueta,
            bg_etiqueta: video.bg_etiqueta,
            fonte: '"Montserrat", sans-serif',
            logo: video.logo,
            formato: videoFormat,
            msgAberturaEnabled,
            msgAberturaTexto: video?.msg_abertura_texto || '',
            msgEncerramentoEnabled,
            msgEncerramentoTexto: video?.msg_encerramento_texto || '',
            redesEnabled,
            redesOutroEnabled,
            redesSociais,
            msgDuracaoSegs,
            outroAudio: video?.outro_audio || null,
            outroTime: video?.outro_audio && Number(video?.tempo_outro) > 0 ? Number(video.tempo_outro) + 3 : 0,
            audioGravado: audioGravadoUrl || null,
            modoGravando: !!modoGravando,
          }}
        />
      </div>

      {/* RODAPÉ REDESENHADO */}
      <footer className="player-footer">
        {/* Seletor de formato com ícones */}
        <div className="format-selector">
          <span className="format-label">Formato</span>
          <div className="format-options">
            {[
              {
                id: "story",
                label: "Story",
                sub: "9:16",
                icon: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="7" y="2" width="10" height="20" rx="2" />
                    <line x1="10" y1="18" x2="14" y2="18" />
                  </svg>
                ),
              },
              {
                id: "feed",
                label: "Feed",
                sub: "4:5",
                icon: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="3" />
                    <circle cx="12" cy="12" r="3" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                ),
              },
              {
                id: "tv_horizontal",
                label: "TV",
                sub: "16:9",
                icon: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <line x1="8" y1="22" x2="16" y2="22" />
                    <line x1="12" y1="19" x2="12" y2="22" />
                  </svg>
                ),
              },
              {
                id: "tv_vertical",
                label: "Painel",
                sub: "9:16",
                icon: (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" />
                    <line x1="9" y1="22" x2="15" y2="22" />
                  </svg>
                ),
              },
            ].map((fmt) => (
              <button
                key={fmt.id}
                className={`format-btn${videoFormat === fmt.id ? " format-btn--active" : ""}`}
                onClick={() => setVideoFormat(fmt.id)}
                title={`${fmt.label} (${fmt.sub})`}
              >
                <span className="format-btn-icon">{fmt.icon}</span>
                <span className="format-btn-label">{fmt.label}</span>
                <span className="format-btn-sub">{fmt.sub}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Botão de download */}
        <div className="download-area">
          {!baixando ? (
            <button
              className={`download-btn${creditos > 0 || podeBaixarSemCredito ? "" : " download-btn--locked"}`}
              onClick={() => {
                if (creditos > 0 || podeBaixarSemCredito) {
                  baixarVideo();
                } else {
                  // Abre automaticamente o modal de comprar créditos
                  abrirModalPlanos();
                }
              }}
              title={
                creditos === 0 && !podeBaixarSemCredito
                  ? "Comprar créditos para baixar"
                  : "Baixar vídeo renderizado"
              }
            >
              <svg className="download-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <span className="download-btn-text">
                {creditos > 0 || podeBaixarSemCredito ? "Baixar Vídeo" : "Comprar Créditos"}
              </span>
              {!podeBaixarSemCredito && (
                <span className="download-btn-cost">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2" />
                    <text x="12" y="16" textAnchor="middle" fontSize="12" fontWeight="700" fill="currentColor">$</text>
                  </svg>
                  5 créditos
                </span>
              )}
            </button>
          ) : (
            <button className="download-btn download-btn--rendering" disabled>
              <span className="download-spinner" />
              <span className="download-btn-text">Renderizando...</span>
            </button>
          )}
        </div>
      </footer>

      {/* Modal de renderização */}
      {baixando && (
        <div className="render-overlay">
          <div className="render-modal">
            <div className="render-modal-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#73207C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            </div>
            <h5 className="render-modal-title">Renderizando vídeo...</h5>
            <div className="render-progress-track">
              <div
                className="render-progress-bar"
                style={{ width: `${Math.floor(progresso * 100)}%` }}
              />
            </div>
            <span className="render-progress-label">{Math.floor(progresso * 100)}%</span>
            <p className="render-modal-hint">Aguarde, isso pode levar alguns segundos.</p>
          </div>
        </div>
      )}
    </div>
  );
}

const Play = forwardRef(PlayInner);
export default Play;
